import _ from "lodash";
import { Types } from "./bambooActions";

const bambooReducers = (state, action) => {
	switch (action.type) {
		case Types.BAMBOO_IMPORT_TIMESHEETS: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.importingTimesheets = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_IMPORT_LEAVE: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.importingLeave = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_SETTINGS_SAVING: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.savingSettings = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_IMPORT_DEPARTMENTS: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.importDepartmentsModal = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_RESYNC_EMPLOYEES: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.resyncingEmployees = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_RESYNC_EMPLOYEE: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.resyncingEmployee = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_SETTINGS: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr = {
				...newState.integration.hris.bambooHr,
				...action.settings,
			};
			return newState;
		}
		case Types.BAMBOO_EMPLOYEE_LINKS: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.loadingEmployees = undefined;
			newState.integration.hris.bambooHr.links = action.links ? action.links : undefined;
			newState.integration.hris.bambooHr.employees = action.employees ? action.employees : undefined;
			newState.integration.hris.bambooHr.ignoredEmployees = action.ignoredEmployees
				? action.ignoredEmployees
				: undefined;

			return newState;
		}
		case Types.BAMBOO_GETTING_EMPLOYEES: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.loadingEmployees = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_UPDATE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.pushChangesModal = action.status ? action.data : undefined;

			return newState;
		}
		case Types.BAMBOO_LOADING_PUSH_CHANGES: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.loadingPushChanges = action.status ? action.status : undefined;

			return newState;
		}
		case Types.BAMBOO_SAVING_PUSH_CHANGES: {
			let newState = _.cloneDeep(state);

			newState.integration.hris.bambooHr.pushingChanges = action.status ? action.status : undefined;

			return newState;
		}

		default:
			return state;
	}
};

export default bambooReducers;